/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandLookupResponseDto } from './BrandLookupResponseDto';
import {
    BrandLookupResponseDtoFromJSON,
    BrandLookupResponseDtoFromJSONTyped,
    BrandLookupResponseDtoToJSON,
} from './BrandLookupResponseDto';

/**
 * 
 * @export
 * @interface SubbrandLookupResponseDto
 */
export interface SubbrandLookupResponseDto {
    /**
     * Sub-brand ID
     * @type {number}
     * @memberof SubbrandLookupResponseDto
     */
    id: number;
    /**
     * Unique code for the sub-brand
     * @type {string}
     * @memberof SubbrandLookupResponseDto
     */
    code: string;
    /**
     * English name of the sub-brand
     * @type {string}
     * @memberof SubbrandLookupResponseDto
     */
    nameEn: string;
    /**
     * Arabic name of the sub-brand
     * @type {string}
     * @memberof SubbrandLookupResponseDto
     */
    nameAr?: string;
    /**
     * Sort order for display
     * @type {number}
     * @memberof SubbrandLookupResponseDto
     */
    sortOrder?: number;
    /**
     * Whether the sub-brand is active
     * @type {boolean}
     * @memberof SubbrandLookupResponseDto
     */
    isActive: boolean;
    /**
     * Creation date
     * @type {Date}
     * @memberof SubbrandLookupResponseDto
     */
    createdAt: Date;
    /**
     * Last update date
     * @type {Date}
     * @memberof SubbrandLookupResponseDto
     */
    updatedAt: Date;
    /**
     * Parent brand lookup ID
     * @type {number}
     * @memberof SubbrandLookupResponseDto
     */
    brandLookupId: number;
    /**
     * Parent brand lookup details
     * @type {BrandLookupResponseDto}
     * @memberof SubbrandLookupResponseDto
     */
    brandLookup?: BrandLookupResponseDto;
}

/**
 * Check if a given object implements the SubbrandLookupResponseDto interface.
 */
export function instanceOfSubbrandLookupResponseDto(value: object): value is SubbrandLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('brandLookupId' in value) || value['brandLookupId'] === undefined) return false;
    return true;
}

export function SubbrandLookupResponseDtoFromJSON(json: any): SubbrandLookupResponseDto {
    return SubbrandLookupResponseDtoFromJSONTyped(json, false);
}

export function SubbrandLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubbrandLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'isActive': json['isActive'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'brandLookupId': json['brandLookupId'],
        'brandLookup': json['brandLookup'] == null ? undefined : BrandLookupResponseDtoFromJSON(json['brandLookup']),
    };
}

export function SubbrandLookupResponseDtoToJSON(value?: SubbrandLookupResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'sortOrder': value['sortOrder'],
        'isActive': value['isActive'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'brandLookupId': value['brandLookupId'],
        'brandLookup': BrandLookupResponseDtoToJSON(value['brandLookup']),
    };
}

